import { Box, Typography } from '@mui/material';
import { ReactNode } from 'react';

interface SsbStepHeaderProps {
  title: string;
  description: string;
  actions?: ReactNode;
}

function SsbStepHeader({ title, description, actions }: SsbStepHeaderProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: '16px',
        marginBottom: '32px',
      }}
    >
      <Box sx={{ maxWidth: '1000px' }}>
        <Typography sx={{ fontSize: '22px', fontWeight: 600 }}>{title}</Typography>
        <Typography sx={{ fontSize: '14px', color: '#718096', marginTop: '8px' }}>{description}</Typography>
      </Box>
      {actions}
    </Box>
  );
}

export default SsbStepHeader;
